import { useContext } from 'react'

import { CarouselDotStyled } from './styles/CarouselDotStyled'
import { CarouselContext } from '../../CarouselContext'
import { Space } from '@ui/elements/Space'

export interface ICarouselDotsProps {
  /** Accessible label for each dot. Defaults to `Slide {n} of {total}`. */
  getItemLabel?: (index: number, itemCount: number) => string
}

export const CarouselDots = ({
  getItemLabel = (index, total) => `Slide ${index + 1} of ${total}`,
}: ICarouselDotsProps) => {
  const { activeIndex, setActiveIndex, itemCount } = useContext(CarouselContext)

  if (itemCount < 2) {
    return null
  }

  return (
    <Space direction='horizontal' align='center' justify='center' size='small'>
      {Array.from({ length: itemCount }, (_, index) => (
        <CarouselDotStyled
          key={index}
          type='button'
          $isActive={index === activeIndex}
          aria-current={index === activeIndex}
          aria-label={getItemLabel(index, itemCount)}
          onClick={() => setActiveIndex(index)}
        />
      ))}
    </Space>
  )
}
